import { render, staticRenderFns } from "./RelationshipStatus.vue?vue&type=template&id=979f4f20"
import script from "./RelationshipStatus.vue?vue&type=script&lang=js"
export * from "./RelationshipStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports